import { DateInt8, isset, sameId } from "@cawita/core-front";
import { EventReservation, Stay } from "@shared/models";


export function filterReservationForEventsOnStay(reservations: EventReservation[], stay: Stay, today: DateInt8) {
    if (!isset(stay)) return [];
    if (!reservations?.length) return [];

    const startDate = Math.max(today, stay.startDate) * 10000;
    const endDate = (stay.endDate * 10000) + 2359;
    return reservations.filter(reservation => {
        const event = reservation?.event;
        if (!isset(event?.partner) || !isset(event?.startDate) || !isset(event?.endDate)) return false;
        if (!sameId(reservation?.event?.partner, stay?.partner)) return false;
        if (startDate > event?.endDate || endDate < event?.startDate) return false;
        return true;
    })
}